/**
 * Link Config Keys
 * Add new keys here to extend the dropdown options in the future.
 * Format: { id: 'KEY_NAME', name: 'Display Label' }
 */
export const LINK_CONFIG_KEYS = [
  {id: 'url_apk', name: 'APK_URL'}
];
